import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../../functions/logging';

import ListItem from './ListItem';
import { RewardsOverview } from './Rewards';
import { getActivityGroups } from '../../api/groups';
import { getUserMonitor, updateUserMonitor } from '../../api/user';
import { calculatePoints } from '../../functions/rewards';

import '../../static/home/Active.css';

// import PageLoader from '../global/PageLoader';
import FadeIn from '../global/FadeIn';
import * as authFns from '../../functions/auth';
import * as homeFns from '../../functions/home';

import localeMessages from '../../locales/home';

import {
	setActivityList, 
	setUserMonitor
} from '../../redux/actions/index';

class Active extends Component {
	constructor(props) {
		super(props);

		this.state = {
			errors: {},
			loadUserMonitor: false,
			arePointsUpdated: false
		};
	}

	componentDidMount() {
		Logger.log(this.constructor.name, "componentDidMount()", this.props, this.state);

		let user_token = authFns.getToken();
		Logger.log(this.constructor.name, "componentDidMount() user_token", user_token, this.props.activityList, homeFns.isActivityListExpired(this.props.activityListTimestamp));
		if (user_token && this.props.currentUser && homeFns.isActivityListExpired(this.props.activityListTimestamp)) {
			this.loadActivityGroups(user_token);
		}

		if (user_token && this.props.currentUser && this.props.userMonitor && this.props.activityList) {
			this.updateUserPoints(this.props.userMonitor, this.props.activityList, this.props.currentUser.user_id, user_token);
			// this.updateUserMonitor(this.props.currentUser.user_id, user_token, this.props.userPilotlyPoints, "active_view");
		}

	}

	componentDidUpdate() {
		let user_token = authFns.getToken();
		if (user_token && this.props.currentUser && !this.state.loadUserMonitor) {
			this.loadUserMonitor(this.props.currentUser.user_id, user_token);
		}
	}

	async loadActivityGroups(user_token) {
		try {
			const result = await getActivityGroups(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadActivityGroups() result", result);
				this.setState({ loading: false });
				this.props.setActivityList(result);
			}
			else {
				Logger.log(this.constructor.name, "loadActivityGroups() err: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
				this.setState({ errors, loading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadActivityGroups() err", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_studies);
			this.setState({ errors, loading: false });
		}
	}

	async loadUserMonitor(user_id, user_token) {
		Logger.log(this.constructor.name, "getUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const results = await getUserMonitor(user_id, user_token);
			if (results) {
				Logger.log(this.constructor.name, "GET User Monitor Successful", results);
				this.setState({ loadUserMonitor: true, errors: {} }, () => {
					this.props.setUserMonitor(results);
				});
			}
			else {
				Logger.log(this.constructor.name, "GET User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
				this.setState({ errors: errors, loadUserMonitor: true });

			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "GET User Monitor Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_loading_user);
			this.setState({ errors: errors, loadUserMonitor: true });
		}
	}

	async updateUserMonitor(user_id, user_token, points, last_view) {
		Logger.log(this.constructor.name, "updateUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const result = await updateUserMonitor(user_id, user_token, points, last_view);
			if (result) {
				Logger.log(this.constructor.name, "UPDATE User Monitor Successful", result);
				this.setState({ errors: {}, arePointsUpdated: true });
				this.props.setUserMonitor(result);
			}
			else {
				Logger.log(this.constructor.name, "UPDATE User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_updating_user);
				this.setState({ errors: errors, arePointsUpdated: true });

			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "UPDATE User Monitor Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = this.props.intl.formatMessage(localeMessages.home_error_updating_user);
			this.setState({ errors: errors, arePointsUpdated: true });
		}
	}

	updateUserPoints(userMonitor, activityList, user_id, user_token) {
		if (userMonitor && activityList && activityList.length) {
			let userPointTotal = 0;
			let userMonitorLastUpdate = userMonitor.updated_at ? moment(userMonitor.updated_at) : null;
			activityList.forEach((group) => {
				let groupStartDate = moment(group.start_date);
				if (group.userData && group.userData.complete && (!userMonitorLastUpdate || userMonitorLastUpdate.isSameOrAfter(groupStartDate))) {
					userPointTotal += calculatePoints(group);
				}
			});
			this.updateUserMonitor(user_id, user_token, userPointTotal, "active_view");
		}
	}

	renderItems() {
		if ((!this.props.activityList || !this.props.activityList.length) && this.state.loading) {
			return (
				<div className="pilotly-home-active-empty"></div>
			);
		}
		else if (!this.props.activityList || !this.props.activityList.length) {
			return (
				<div className="pilotly-home-active-empty">
					<FormattedMessage
						id="active.studies.none"
						defaultMessage={"No studies are currently available."}
					/>
				</div>
			);
		}
		return this.props.activityList.map((study, index) => {
			Logger.log(this.constructor.name, "renderItems() study", study.title);
			return (
				<ListItem key={"active-item-" + study._id.valueOf()} 
					{...this.props}
					index={index}
					item={study}
				/>
			);
		});
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		let pilotlyPoints = this.props.userPilotlyPoints;
		
		return (
			<FadeIn>
				<div className="pilotly-home-active">
					<RewardsOverview intl={this.props.intl} userPilotlyPoints={pilotlyPoints} overviewLoading={this.props.userMonitorLoading} />
					{this.renderItems()}
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	Logger.log(this.constructor.name, "mapStateToProps()", state);
	return {
		currentUser: state.currentUser.currentUser,
		userMonitor: state.currentUser.userMonitor,
		userPilotlyPoints: state.currentUser.userPilotlyPoints,
		activityList: state.homeLists.activityList,
		activityListTimestamp: state.homeLists.activityListTimestamp,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setActivityList,
		setUserMonitor
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Active));



// WEBPACK FOOTER //
// ./src/components/home/Active.js